export default {
  // Page Meta
  meta: {
    title: 'Über uns | NutriBot',
    description: 'Entdecke, wie NutriBot die Ernährung mit KI-gestützter Personalisierung, wissenschaftlicher Präzision und intelligenter Automatisierung revolutioniert.',
  },

  // Hero Section
  hero: {
    title: 'Über uns',
    tagline: 'Ernährung neu gedacht. Präzise. Persönlich. Intelligent.',
  },

  // Opening Statement
  opening: {
    paragraph1: 'Ernährung beeinflusst alles: Gesundheit, Energie, Leistungsfähigkeit, Lebensqualität und Langlebigkeit. Und doch war sie jahrzehntelang kompliziert, widersprüchlich und unübersichtlich.',
    paragraph2: 'NutriBot ändert das. Radikal.',
    paragraph3: 'Wir haben NutriBot mit einer klaren Mission entwickelt:',
    mission: 'Jeder Mensch soll Zugang zu einer perfekt auf ihn abgestimmten Ernährung haben – einfach, intelligent und wissenschaftlich fundiert.',
  },

  // Vision Section
  vision: {
    title: 'Unsere Vision',
    intro: 'Wir glauben an eine Zukunft, in der Ernährung nicht mehr geraten, sondern präzise berechnet wird. Eine Zukunft, in der Menschen ohne Verzicht, ohne endlose Diäten und ohne Unsicherheit ihre Ziele erreichen.',
    goals: {
      title: 'Alles beginnt mit der richtigen Ernährung – zur richtigen Zeit – für den richtigen Menschen.',
      items: [
        'Abnehmen',
        'Muskelaufbau',
        'Gesundheit',
        'Prävention',
        'Leistungssteigerung',
      ],
    },
    statement: 'Unsere Vision ist es, die weltweit führende KI-Ernährungsplattform aufzubauen und Ernährung so selbstverständlich, personalisiert und zuverlässig zu machen wie Online-Banking oder Navigation.',
  },

  // What Makes Us Unique
  unique: {
    title: 'Was NutriBot einzigartig macht',
    subtitle: 'NutriBot ist kein normaler Ernährungsplan. Es ist ein intelligentes System.',
    features: [
      {
        icon: 'ri-brain-line',
        title: 'KI-Intelligenz',
        description: 'Künstliche Intelligenz, die individuelle Daten analysiert',
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Wissenschaftlich fundiert',
        description: 'Wissenschaftlich fundierte Algorithmen statt Trends & Mythen',
      },
      {
        icon: 'ri-refresh-line',
        title: 'Dynamische Anpassung',
        description: 'Dynamische Anpassung an Alltag, Fortschritt und Ziele',
      },
      {
        icon: 'ri-chat-4-line',
        title: '24/7 KI-Coach',
        description: '24/7 KI-Coach, der begleitet, motiviert und optimiert',
      },
      {
        icon: 'ri-shopping-cart-line',
        title: 'Automatisierte Logik',
        description: 'Automatische Einkaufs- & Rezeptlogik für maximale Alltagstauglichkeit',
      },
    ],
    closing: 'NutriBot lernt mit jeder Entscheidung dazu – und wird mit der Zeit immer besser für dich.',
  },

  // Target Audience
  audience: {
    title: 'Für wen wir NutriBot entwickelt haben',
    subtitle: 'Für Menschen, die echte Resultate wollen.',
    groups: [
      'Für alle, die abnehmen möchten – auch ohne Sport',
      'Für Menschen mit gesundheitlichen Herausforderungen',
      'Für Berufstätige, die keine Zeit für komplizierte Planung haben',
      'Für alle, die ihrem Körper wieder vertrauen wollen',
      'Für Einsteiger genauso wie für ambitionierte High-Performer',
    ],
    closing: 'Eine Plattform. Unzählige Lebenssituationen.',
  },

  // Values
  values: {
    title: 'Unsere Werte',
    list: [
      {
        icon: 'ri-focus-line',
        title: 'Präzision statt Zufall',
        description: 'Wir arbeiten datenbasiert, nicht nach Bauchgefühl.',
      },
      {
        icon: 'ri-lightbulb-flash-line',
        title: 'Einfachheit statt Überforderung',
        description: 'Komplexe Prozesse – einfache Lösungen.',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Vertrauen statt leere Versprechen',
        description: 'Nachvollziehbar, transparent und verantwortungsvoll.',
      },
      {
        icon: 'ri-rocket-line',
        title: 'Technologie im Dienst des Menschen',
        description: 'Nicht ersetzen – sondern unterstützen.',
      },
    ],
  },

  // Why NutriBot
  why: {
    title: 'Warum NutriBot?',
    reasons: [
      'Weil Ernährung kein Glücksspiel sein darf.',
      'Weil dein Körper einzigartig ist.',
      'Weil Zeit wertvoll ist.',
      'Und weil moderne Technologie heute mehr kann als jemals zuvor.',
    ],
    conclusion: 'NutriBot verbindet Wissenschaft, KI und Alltag zu einem System, das funktioniert.',
  },

  // CTA Footer
  cta: {
    brand: 'NutriBot.',
    tagline: 'Ernährung. Automatisiert. Perfektioniert.',
    primaryButton: 'Kostenlos starten',
    secondaryButton: 'Mehr erfahren',
  },
  happyUsers: 'Zufriedene Nutzer'
};
